import React from "react";
import DamageForms from "./DamageForms";

const ViewDamageReport = () => {
    return( 
        <DamageForms type="View" />
    )
}

export default ViewDamageReport